export default __webpack_public_path__ + "static/BEST_warsaw-1024x519-6d8ea733e0d70081d7d82412f2a54938.png";